/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TypeEnum {
  PROJECT = "project",
}
